var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"search"},[_c('SearchBar',{attrs:{"searchStyle":_vm.searchStyle},on:{"searchValue":_vm.searchValue,"clearValue":_vm.clearValue}}),_c('ReportList',{ref:"report"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }